import { Component } from '@angular/core';
import { NavController, AlertController, NavParams, App, Platform, ToastController, ModalController } from 'ionic-angular';
import { LogoutProvider } from '../../providers/logout';
import { LoadingProvider } from '../../providers/loading';
import { TeamappProvider } from '../../providers/teamapp';
import { AlertProvider } from '../../providers/alert';
import { ImageProvider } from '../../providers/image';
import { DataProvider } from '../../providers/data';
import { UserProvider } from '../../providers/user';
import { Settings } from '../../settings';
import { Validator } from '../../validator';
import { Camera } from '@ionic-native/camera';
import { Http } from "@angular/http";

declare var google;

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  user: any = {
    gender: 'male',
    dob: new Date(),
    location: '',
    publicVisibility: true,
    notDisturbFrom: '',
    notDisturbTill: ''
  };
  user_db: any;
  private alert;
  showOnline: any = false;
  isPushEnabled: any = false;
  isPhonebookVisible: any = false;
  isBrowser: any = false;
  isNotDisturbEnable: any = false;
  places: any = [];
  version:string = Settings.appVersion;
  // HomePage
  // This is the page where the user is directed after successful login and email is confirmed.
  // A couple of profile management function is available for the user in this page such as:
  // Change name, profile pic, email, and password
  // The user can also opt for the deletion of their account, and finally logout.
  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public navParams: NavParams, public app: App,
    public logoutProvider: LogoutProvider, public loadingProvider: LoadingProvider, public imageProvider: ImageProvider, public alertProvider: AlertProvider, public dataProvider: DataProvider,
    public camera: Camera, public platform: Platform, public toast: ToastController, public modal: ModalController, public http: Http, public teamappProvider: TeamappProvider, public userProvider: UserProvider) {
    this.logoutProvider.setApp(this.app);
    if (this.platform.is('core')) this.isBrowser = true;

    if (localStorage.getItem('isPushEnabled') == 'true') this.isPushEnabled = true;
    else this.isPushEnabled = false;

    if (localStorage.getItem('showOnline') == 'true') this.showOnline = true;
    else this.showOnline = false;

  }

  ionViewDidLoad() {
    // Observe the userData on database to be used by our markup html.
    // Whenever the userData on the database is updated, it will automatically reflect on our user variable.
    this.loadingProvider.show();
    this.teamappProvider.http_request('action=get_settings', 'settings', false, true).then(data => {
        this.user_db = data;
        if(this.user_db.phonebookvisibility == 1) {
          this.isPhonebookVisible = true;
        }

        if(this.user_db.not_disturb_from != '00:00:00' && this.user_db.not_disturb_from != '00:00:00') {
          this.isNotDisturbEnable = true;
        }

        this.loadingProvider.hide();

        this.user.notDisturbFrom = this.user_db.not_disturb_from;
        this.user.notDisturbTill = this.user_db.not_disturb_till;

        this.user.name = this.user_db.name;
        this.user.surname = this.user_db.surname;

        this.user.dob = this.user_db.birthday;
        this.user.img = this.user_db.image;

        console.log("SETTINGS");
        console.log(data);
    });

  }

  search() {
    console.log(this.user.location);
    let textbox = document.getElementById('txtHome').getElementsByTagName('input')[0];
    let autocomplete = new google.maps.places.Autocomplete(textbox, { types: ['geocode'] });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      // retrieve the place object for your use
      let place = autocomplete.getPlace();
      this.user.location = place.formatted_address;
      console.log(this.user.location);
    });
  }

  changeStatus() {
    console.log(this.showOnline);
    localStorage.setItem('showOnline', this.showOnline);

  }

  changePhonebookVisibility() {
    console.log(this.isPhonebookVisible);
    if(this.isPhonebookVisible == true) {
        this.teamappProvider.http_request('action=update_phonebookvisibility&user_phonebookvisibility=1', 'settings', false, true).then(data => {

        });
    } else {
        this.teamappProvider.http_request('action=update_phonebookvisibility&user_phonebookvisibility=0', 'settings', false, true).then(data => {

        });
    }
  }

  changeVisibility() {

  }

  save() {
    this.teamappProvider.http_request('action=update_settings&user_mail='+this.user_db.official_mail+'&user_notdisturbfrom='+this.user.notDisturbFrom+'&user_notdisturbtill='+this.user.notDisturbTill+'&user_mobile='+this.user_db.mobile+'&user_phone='+this.user_db.phone+'&user_name='+this.user.name+'&user_surname='+this.user.surname+'&user_gender='+this.user_db.gender+'&user_birthday='+this.user_db.dob, 'settings', false, true).then(data => {
        console.log('not disturb A'+this.user.notDisturbFrom);
        console.log('not disturb B'+this.user.notDisturbTill);

        let requestData: any = data;

        this.userProvider.setUserName(this.user.name, this.user.surname);
        let toast = this.toast.create({ message: 'Erfolgreich gespeichert', duration: 2000 });
        toast.present();
    });
  }

  showBlockedList() {
    this.modal.create("BlockedlistPage").present();
  }
  changeNotification() {
    if (this.isPushEnabled == true) {
      //Registering for push notification
      (<any>window).FirebasePlugin.hasPermission(data => {
        if (data != true) {
          (<any>window).FirebasePlugin.grantPermission(hasPermission => {
              if(hasPermission == 'granted') {
                  (<any>window).FirebasePlugin.getToken(token => {
                      this.updateToken(token);
                      localStorage.setItem('isPushEnabled', 'true');
                      this.isPushEnabled = true;
                  }).catch(err => {
                      console.log(err);
                  });
                  (<any>window).FirebasePlugin.onTokenRefresh(token => {
                      localStorage.setItem('isPushEnabled', 'true');
                      this.updateToken(token);
                  });
              }
          });
        }
        else {

          (<any>window).FirebasePlugin.getToken(token => {
            console.log(token);
            this.updateToken(token);
            localStorage.setItem('isPushEnabled', 'true');
            this.isPushEnabled = true;
          }).catch(err => {
            console.log(err);
          });
          (<any>window).FirebasePlugin.onTokenRefresh(token => {
            localStorage.setItem('isPushEnabled', 'true');
            this.updateToken(token);
          });
        }
      });

    }
    else {
      this.isPushEnabled == false;
      localStorage.setItem('isPushEnabled', 'false');
    }
  }

  updateToken(token: string) {
    this.teamappProvider.http_request('action=update_token&user_push_token='+token, 'settings', false, true).then(data => {
    });
  }
  // Change user's profile photo. Uses imageProvider to process image and upload on Firebase and update userData.
  setPhoto() {
    // Ask if the user wants to take a photo or choose from photo gallery.
    this.alert = this.alertCtrl.create({
      title: 'Profilbild ändern',
      message: 'Neues Profilbild auswählen oder ein Bild aufnehmen?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Aus der Galerie auswählen',
          handler: () => {
            // Call imageProvider to process, upload, and update user photo.
            this.imageProvider.setProfilePhoto(this.user, this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Bild aufnehmen',
          handler: () => {
            // Call imageProvider to process, upload, and update user photo.
            this.imageProvider.setProfilePhoto(this.user, this.camera.PictureSourceType.CAMERA);
          }
        }
      ]
    }).present();
  }


  // Change user's password, this option only shows up for users registered via Firebase.
  // The currentPassword is first checked, after which the new password should be entered twice.
  // Uses password validator from Validator.ts.
  setPassword() {
    this.alert = this.alertCtrl.create({
      title: 'Passwort ändern',
      message: "",
      inputs: [
        {
          name: 'password',
          placeholder: 'Neues Passwort',
          type: 'password'
        },
        {
          name: 'confirmPassword',
          placeholder: 'Neues Passwort bestätigen',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Speichern',
          handler: data => {
            let currentPassword = data["currentPassword"];
            // Check if currentPassword entered is correct
            this.loadingProvider.show();

                let password = data["password"];
                // Check if entered password is not the same as the currentPassword
                if (password != currentPassword) {
                  if (password.length >= Validator.profilePasswordValidator.minLength) {
                    if (Validator.profilePasswordValidator.pattern.test(password)) {
                      if (password == data["confirmPassword"]) {
                        // Update password on Firebase.

                            this.teamappProvider.http_request('action=update_password&user_password='+password, 'settings', false, true).then(data => {
                                this.loadingProvider.hide();
                                Validator.profilePasswordValidator.pattern.test(password);
                                this.alertProvider.showPasswordChangedMessage();
                            });

                      } else {
                        this.alertProvider.showErrorMessage('profile/passwords-do-not-match');
                        this.loadingProvider.hide();
                      }
                    } else {
                      this.alertProvider.showErrorMessage('profile/invalid-chars-password');
                      this.loadingProvider.hide();
                    }
                  } else {
                    this.alertProvider.showErrorMessage('profile/password-too-short');
                    this.loadingProvider.hide();
                  }
                }

          }
        }
      ]
    }).present();
  }

  // Log the user out.
  logout() {
    this.alert = this.alertCtrl.create({
      title: 'Abmelden',
      message: 'Jetzt abmelden?',
      buttons: [
        {
          text: 'Abbrechen'
        },
        {
          text: 'Abmelden',
          handler: data => { this.logoutProvider.logout(); }
        }
      ]
    }).present();
  }

  resetDisturbTime() {
    if(!this.isNotDisturbEnable) {
      this.user.notDisturbFrom = '';
      this.user.notDisturbTill = '';
    }
  }

  checkDisturbTime() {
    if(this.user.notDisturbFrom != '' && this.user.notDisturbFrom >= this.user.notDisturbTill && this.user.notDisturbTill != '') {

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts